import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import {
    IPackage,
    NugetType,
} from '@models';
import { FileDownloadService } from '@services';

@Component({
    selector: 'ui-nuget-changelog',
    templateUrl: './nuget-changelog.html',
    styleUrls: [
        './nuget-changelog.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NugetChangelogComponent {
    public NugetType = NugetType;

    @Input()
    public package!: IPackage;

    @Input()
    public type!: string;

    @Input()
    public isDownloadEnabled!: boolean;

    @Input()
    public downloadLink!: string;

    constructor(
        private _downloadService: FileDownloadService,
    ) { }

    public downloadPackage(event: MouseEvent) {
        event.preventDefault();
        this._downloadService.download(this.downloadLink);
    }
}
